<template>
  <div class="QzContent">
    <div class="QzContent-list">
      <template v-for="(item, index) in listProps">
        <template v-if="(item.isShow && item.isShow(item)) || !item.isShow">
          <!-- 附件上传 -->
          <div
            style="margin-top:12px"
            v-if="item.type == 'file'"
            :key="'row0' + index"
          >
            <van-uploader
              v-if="isApply"
              :disabled="!isApply"
              v-model="fileList"
              :after-read="afterRead"
              :max-size="10 * 1024 * 1024"
              @oversize="onOversize"
              :max-count="1"
              :preview-image="false"
            >
              <van-field
                label="上传附件"
                input-align="right"
                readonly
                :required="item.required"
              >
                <template #input>
                  <template v-if="isApply">
                    <div class="fujianImg"></div>
                  </template>
                  <template v-else>
                    <span v-if="JSON.stringify(filemap) == '[]'">无</span>
                    <span v-else></span>
                  </template>
                </template>
              </van-field>
            </van-uploader>
            <van-field v-else label="上传附件" input-align="right" readonly>
              <template #right-icon>
                <span v-if="filemap.length == 0">无</span>
              </template>
            </van-field>
            <ul id="myMain" v-if="filemap.length > 0">
              <li v-for="(item, index) in filemap" :key="index">
                <img
                  v-if="item.type"
                  :src="require(`@/assets/images/${item.type}.png`)"
                  alt=""
                />
                <img v-else :src="item.src" alt="" />
                <div>
                  <h3>{{ item.fileName }}</h3>
                  <span>{{ item.fileSize }}</span>
                </div>
                <iconpark-icon
                  v-if="isApply"
                  class="delete"
                  size="16"
                  name="shanchu"
                  @click="deleteImg"
                ></iconpark-icon>
              </li>
            </ul>
          </div>
          <van-cell-group
            v-else-if="item.type == 'textarea'"
            class="qz-textarea"
            :key="'row1' + index"
          >
            <span class="qz-textarea-title">{{ item.label }}</span>
            <van-field
              v-model="itemList[item.prop]"
              type="textarea"
              rows="2"
              autosize
              input-align="left"
              :readonly="!isApply || item.readonly"
              :required="item.required"
            />
          </van-cell-group>
          <van-field
            v-else
            v-model="itemList[item.prop]"
            :label="item.label"
            :readonly="!isApply || item.readonly"
            :required="item.required"
            :placeholder="item.placeholder || '暂无数据'"
            :right-icon="item.rightIcon"
            :key="'row2' + index"
          />
          <qz-split v-if="item.line" :key="'row' + index"></qz-split>
        </template>
      </template>
    </div>
    <qz-split></qz-split>
  </div>
</template>

<script>
export default {
  name: "QzContent",
  props: {
    isApply: {
      type: Boolean,
      default: false
    },
    itemList: {
      type: Object,
      required: true,
      default: () => {}
    },
    listProps: {
      type: Array,
      default: () => []
    },
    filemap: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      file: {},
      fileList: []
    };
  },
  methods: {
    // 附件上传
    afterRead(file) {
      let obj = {
        fileName: file.file.name,
        fileSize: file.file.size,
        src: file.content
      };
      this.filemap.push(obj);

      // 此时可以自行将文件上传至服务器
      this.file = file.file;
      this.info.filename = file.file.name;
    },
    onOversize(file) {
      this.$toast.fail("文件大小不能超过10M");
    },
    deleteImg(index) {
      this.fileList.splice(index, 1);
      this.filemap.splice(index, 1);
      this.file = {};
    }
  }
};
</script>
<style lang="less" scoped>
.QzContent {
  padding: 10px 15px;
  .QzContent-list {
    border-radius: 8px;
    & > div:first-child {
      border-radius: 8px 8px 0 0;
    }
    & > div:last-child {
      border-radius: 0 0 8px 8px;
      .van-cell {
        border-radius: 0 0 8px 8px;
      }
    }
    .qz-textarea-title {
      color: #757da3;
      font-family: PingFangSC;
      padding: 10px 16px;
      font-size: 16px;
    }
    #myMain {
      background-color: #fff;
      padding: 12px 0 12px 40px;
      li {
        position: relative;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        border-bottom: 1px solid #e5e5e5;
        padding: 8px 30px 8px 0;
        img,
        .imgIcon {
          margin-right: 10px;
          width: 34px;
          height: 34px;
        }
        h3 {
          font-family: MicrosoftYaHei;
          font-size: 14px;
          color: #333333;
          margin-bottom: 2px;
        }
        span {
          font-family: MicrosoftYaHei;
          font-size: 12px;
          color: #b2b2b2;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/QzContent/index.vue